import ExaminationSubmitModal, { ExaminationSubmitModalProps } from './ExaminationSubmitModal';

export default ExaminationSubmitModal;
export type { ExaminationSubmitModalProps };
